/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {unregisterCampaign} from '../api'

export const useMutationUnregisterCampaign = createReactQueryMutationHook('unregisterCampaign', unregisterCampaign)
